import {Component, Input} from '@angular/core';
import {TabComponent} from '../tab/tab.component';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent {

  @Input()
  public verticalMode: boolean;

  public tabs: TabComponent[] = [];

  public addTab(tab: TabComponent): void {
    this.tabs.push(tab);
  }

  public selectTab(selectedTab: TabComponent): void {
    if (!selectedTab.disabled) {
      this.tabs.map(tab => tab.unselect());
      selectedTab.select();
      selectedTab.navigate();
    }
  }

  public removeTab(tab: TabComponent): void {
    const index = this.tabs.indexOf(tab);
    if (index > -1) {
      this.tabs.splice(index, 1);
    }
  }
}
